import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';
import {SimpleSelect} from "../SelectSubMenuOptions/SimpleSelect";
import Checkbox from "../Checkbox";
import type {SDataRelatedOptions} from "./types";

export type featureAllowUserToSelectDatePeriodCallbacks = {
    onChange: (options: SDataRelatedOptions) => void;
}


export class featureAllowUserToSelectDatePeriod {

    private readonly callbacks: featureAllowUserToSelectDatePeriodCallbacks;

    constructor(
        root: HTMLDivElement,
        itemId: string,
        options: SDataRelatedOptions,
        allAvailableEntries: { id: string, name: string }[],
        callbacks: featureAllowUserToSelectDatePeriodCallbacks
    ) {
        this.callbacks = callbacks;

        console.log('featureAllowUserToSelectDatePeriod, constructor, options', options);
        if (options.date_first === null) {
            alert('featureAllowUserToSelectDatePeriod, constructor, date_first is null');
        }
        if (options.date_second === null) {
            options.compare_dates = false;
            console.log('featureAllowUserToSelectDatePeriod, constructor, set default compare_dates to false')
        }

        root.innerHTML = `
            <div class="select-date-from"></div>
            <div class="js-compare-date" style="color: white;
display: flex;
align-items: center;
height: 22px;
"></div>
            <div class="select-date-to"></div>
        `;

        new SimpleSelect(
            root.querySelector('.select-date-from'),
            {
                multiple: false,
                allAvailableEntries: allAvailableEntries,
                selectedIds: [options.date_first],
            },
            {
                onChangeWhileOpen: (values: string[]) => {
                    console.debug('SimpleSelect, onChange, from', values);
                    options = {
                        ...options,
                        date_first: values[0],
                    }
                    this.callbacks.onChange(options);
                    return true;
                }
            }
        )

        let checkbox = Checkbox(
            {
                label: get(_)('compare'),
                checked: options.compare_dates || false,
                mode: 'white-checkbox',
                disabled: false,
            },
            {
                onChange: (checked: boolean) => {
                    console.debug('Checkbox, onChange, compareDates', checked);
                    options = {
                        ...options,
                        compare_dates: checked,
                    }
                    this.setDateSecondEnable(root, checked);

                    this.callbacks.onChange(options);
                }
            }
        )
        root.querySelector('.js-compare-date')?.appendChild(checkbox.element);

        new SimpleSelect(
            root.querySelector('.select-date-to'),
            {
                multiple: false,
                allAvailableEntries: allAvailableEntries,
                selectedIds: [options.date_second],
            },
            {
                onChangeWhileOpen: (values: string[]) => {
                    console.debug('SimpleSelect, onChange, to ', values);
                    options = {
                        ...options,
                        date_second: values[0],
                    }
                    this.callbacks.onChange(options);
                    return true;
                }
            }
        )

        root.style.display = 'flex';

        this.setDateSecondEnable(root, options.compare_dates);
    }


    setDateSecondEnable(root: HTMLDivElement, checked: boolean) {
        if (checked) {
            (root.querySelector('.select-date-to') as HTMLSelectElement).style.opacity = '1';
            (root.querySelector('.select-date-to') as HTMLSelectElement).style.pointerEvents = 'auto';
        } else {
            (root.querySelector('.select-date-to') as HTMLSelectElement).style.opacity = '0.3';
            (root.querySelector('.select-date-to') as HTMLSelectElement).style.pointerEvents = 'none';
        }
    }

}